// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardFullscreen.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var ReactDOM = require('react-dom');
  var connect = require('share/enhancers/Izenda.Connect');
  var DashboardTile = require('../DashboardGrid/DashboardTile/Izenda.DashboardTile');
  var SliderBox = require('share/components/controls/Izenda.SliderBox');
  var Fullscreen = require('share/components/controls/Izenda.Fullscreen');
  var classnames = require('classnames');
  const { isNil, assign, map } = require('lodash/fp');
  var SCREEN_RATIO = 7;

  var DashboardFullscreen = function(props) {
    var dashboardDetail = props.store.dashboardDetail;
    var localization = props.localization;

    // Config for slider
    var centerPadding = Math.round(this.props.width / SCREEN_RATIO);
    var settings = null;
    if (dashboardDetail.dashboard.activeDashboardParts.length > 1) {
      settings = {
        centerMode: true,
        centerPadding: centerPadding,
        slidesToShow: 1,
        arrows: true,
        dots: false,
        lazyLoad: true,
        pauseOnHover: false,
        draggable: false
      };

      if (
        (props.store.model.autoDurationMinute || props.store.model.autoDurationSecond) &&
        props.store.dashboardDesignerMode.isFullscreen
      ) {
        var minute = 0;
        if (!isNil(props.store.model.autoDurationMinute)) minute = props.store.model.autoDurationMinute;

        var second = 0;
        if (!isNil(props.store.model.autoDurationSecond)) second = props.store.model.autoDurationSecond;

        settings = assign(
          {
            autoplaySpeed: minute * 60 * 1000 + second * 1000,
            autoplay: true
          },
          settings
        );
      }
    }
    // Effect when resize event
    var style = {
      width: this.props.width + 'px',
      paddingBottom: '50px'
    };

    function exitCallback() {
      props.store.dashboardDesignerMode.exitFullscreen();
    }

    /**
     * Render dashboard tiles
     */
    function renderDashboardTiles() {
      return map(function(dashboardPart) {
        return (
          <div key={dashboardPart.id} className="u_fullHeight">
            <DashboardTile {...props} dashboardPart={dashboardPart} viewMode fullScreen />
          </div>
        );
      }, dashboardDetail.dashboard.activeDashboardParts);
    }

    /**
     * Render slider box
     */
    function renderSliderBox() {
      return (
        <div className="u_fullHeight dashboard-fullscreen" style={style}>
          {dashboardDetail.dashboard.activeDashboardParts.length > 1 ? (
            <SliderBox settings={settings}>{renderDashboardTiles()}</SliderBox>
          ) : (
            renderDashboardTiles()
          )}
        </div>
      );
    }

    return (
      <Fullscreen exitCallback={exitCallback}>
        {!isNil(props.dashboardDetail.dashboard.name) && (
          <div className="u_paddingAll dashboard-name">
            {props.dashboardDetail.dashboard.name}
            <i
              title={localization.getText('DASHBOARD_TITLE_EXIT_FULL_SCREEN_MODE')}
              className="icon-cancel u_inlineBlock u_marginLeft pull-right selectable"
              onClick={exitCallback}
            />
          </div>
        )}
        {renderSliderBox()}
      </Fullscreen>
    );
  };

  DashboardFullscreen.propTypes = {
    store: React.PropTypes.object
  };

  module.exports = connect()(DashboardFullscreen);
})();



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardPresentation/Izenda.DashboardFullscreen.jsx